import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import LoadingPage from "../../Components/layouts/loading";
import AssetsTrackingTable from "./Assets Tracking/assets_tracking_table";
import { useSelector } from "react-redux";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcSms } from "react-icons/fc";
import { BsPostcardHeartFill } from "react-icons/bs";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import { useSearchParams } from "react-router-dom";

const AssetsTracking = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [farmName, setFarmName] = useState();
  const store = useSelector((store) => store.login.user);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    resourceName: "",
    vendor: "",
    farmName: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");
  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", getFilteredURL("/asset/getAsset/", page, filters))
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.assetCount / 50));
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/clientProject/getCpNameForClients/")
      .then((res) => {
        if (res.status === 200) {
          setFarmName(res?.data?.clientProjectsData);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSms className="fs-2  me-1" /> Track your assets
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Track & manage your assets.
                </h4>
              </div>
              <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end">
                  <a href={"/resources-assets/new"} className="btn btn-primary">
                    {" "}
                    <BsPostcardHeartFill className="fs-3 me-2" />
                    ADD NEW ASSET
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div
                        className={`accordion-body pt-0 ${
                          themeSet === "dark" ? "text-light" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Search Asset:"
                              value={filters.resourceName}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  resourceName: e.target.value,
                                })
                              }
                              placeholder="search asset name..."
                            ></DynamicFilterInput>
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="Search vendor:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  vendor: e.target.value,
                                })
                              }
                              value={filters.vendor}
                              placeholder="search vendor name..."
                            ></DynamicFilterInput>
                          </div>
                          {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                            store.Role ===
                              process.env.REACT_APP_ROLE_ADMIN) && (
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search farm name:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    farmName: e.target.value,
                                  })
                                }
                                value={filters.farmName}
                              >
                                <option value="">select all</option>

                                {farmName &&
                                  farmName?.map((state, index) => (
                                    <option
                                      key={index}
                                      value={state?.clientName}
                                    >
                                      {state?.clientName}
                                    </option>
                                  ))}
                              </DynamicFilterSelect>
                            </div>
                          )}

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      resourceName: "",
                                      vendor: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`accordion-body d-none d-md-block ${
                        themeSet === "dark" ? "text-light" : ""
                      }`}
                    >
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Search Asset:"
                            value={filters.resourceName}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                resourceName: e.target.value,
                              })
                            }
                            placeholder="search asset name..."
                          ></DynamicFilterInput>
                        </div>

                        <div className="col-12">
                          <DynamicFilterInput
                            label="Search vendor:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                vendor: e.target.value,
                              })
                            }
                            value={filters.vendor}
                            placeholder="search vendor name..."
                          ></DynamicFilterInput>
                        </div>

                        {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                          store.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search farm name:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  farmName: e.target.value,
                                })
                              }
                              value={filters.farmName}
                            >
                              <option value="">select all</option>

                              {farmName &&
                                farmName?.map((state, index) => (
                                  <option key={index} value={state?.clientName}>
                                    {state?.clientName}
                                  </option>
                                ))}
                            </DynamicFilterSelect>
                          </div>
                        )}

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    resourceName: "",
                                    vendor: "",
                                    farmName: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block d-md-block">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/qo2iLN0nDo0"}
                  id={"model-viedo"}
                  name={"track your assets"}
                ></CustomViedoCard>
              </div>
              <div className="card mt-2 border-0">
                <div className="card-body p-0">
                  <img
                    className="d-none d-sm-block"
                    src="https://res.cloudinary.com/dezupfsqo/image/upload/v1733490497/3_wd3qr6.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data && (
                  <AssetsTrackingTable
                    EX={data?.asset}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    <a
                      href={"/resources-assets/new"}
                      className="btn btn-primary"
                    >
                      {" "}
                      <BsPostcardHeartFill className="fs-3 me-2" />
                      ADD NEW ASSET
                    </a>
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.asset?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>

              <div className="card mt-2 border-0">
                <div className="card-body p-0">
                  <img
                    className="d-block d-sm-none"
                    src="https://res.cloudinary.com/dezupfsqo/image/upload/v1733490497/3_wd3qr6.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-block d-md-none d-lg-none">
            <CustomViedoCard
              viedoLink={"https://www.youtube.com/embed/qo2iLN0nDo0"}
              id={"model-viedo2"}
              name={"track your assets"}
            ></CustomViedoCard>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AssetsTracking;
